export default __webpack_public_path__ + "static/Holistic Development-99a35a0f5ab4dddf629500d359e64207.jpg";